export enum InvoiceStatuses {
    Draft = 'D',
    QueuedForApproval = 'Q',
    ApprovedForPayment = 'A',
    Hold = 'H',
    Paid = 'P',
}
